var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashBoardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 20C1.34315 20 0 18.6569 0 17V9.33613C0 8.48567 0.360964 7.67518 0.993106 7.10625L7.9931 0.806251C9.13402 -0.220572 10.866 -0.220574 12.0069 0.80625L19.0069 7.10625C19.639 7.67518 20 8.48567 20 9.33613V17C20 18.6569 18.6569 20 17 20H3ZM18 9.33613V17C18 17.5523 17.5523 18 17 18H14V13C14 11.3432 12.6569 10 11 10H9C7.34315 10 6 11.3432 6 13V18H3C2.44772 18 2 17.5523 2 17V9.33613C2 9.05265 2.12032 8.78248 2.33104 8.59284L9.33103 2.29284C9.71134 1.95056 10.2887 1.95056 10.669 2.29284L17.669 8.59284C17.8797 8.78248 18 9.05265 18 9.33613ZM8 18V13C8 12.4478 8.44772 12 9 12H11C11.5523 12 12 12.4478 12 13V18H8Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardIcon);
export default __webpack_public_path__ + "static/media/DashBoard_icon.8b605c31d9ea71080e02174d5da77f36.svg";
export { ForwardRef as ReactComponent };